var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4458,
    cy: 16.7973,
    r: 15.3266,
    fill: "#27AE60",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2957 23.8723C12.9692 23.8723 12.6698 23.7635 12.4249 23.5186L7.00994 18.1036C6.52014 17.6138 6.52014 16.8519 7.00994 16.3621C7.49974 15.8723 8.26162 15.8723 8.75142 16.3621L13.3229 20.9063L24.1801 10.0763C24.6699 9.58653 25.4318 9.58653 25.9216 10.0763C26.4114 10.5661 26.4114 11.328 25.9216 11.8178L14.1936 23.5186C13.9215 23.7635 13.6222 23.8723 13.2957 23.8723Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeApproved);
export default __webpack_public_path__ + "static/media/Badge Approved.e4bc64e828d5650f511c6d72131d6b32.svg";
export { ForwardRef as ReactComponent };